import './App.css';
import { About } from './components/About';
import { Hero } from './components/Hero';
import { NavBar } from './components/NavBar';
import { Projects } from './components/Projects';
import { Experience } from './components/Experience';
import { ContactMe } from './components/ContactMe';
import { Footer } from './components/Footer';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { SpeedInsights } from '@vercel/speed-insights/react';
const TRACKING_ID = "G-WGX1R6NYZB";

function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
  }, []);

  return (
    <main>
      <NavBar />
      <Hero />
      <About />
      <Projects />
      <Experience />
      <ContactMe />
      <Footer />
      <SpeedInsights />
    </main>
  );
}

export default App;
